export default __webpack_public_path__ + "static/media/ahri_card.70fd40ad.png";